import root from "@/locales/nl-NL/root";
import global from "@/locales/nl-NL/global";
import error403 from "@/locales/nl-NL/errors/403";
import error404 from "@/locales/nl-NL/errors/404";
import error500 from "@/locales/nl-NL/errors/500";
import error503 from "@/locales/nl-NL/errors/503";
import error504 from "@/locales/nl-NL/errors/504";
import maintenance from "@/locales/nl-NL/auth/maintenance";
import toast from "@/locales/nl-NL/toast/toast";
import login from "@/locales/nl-NL/auth/login";
import onboarding from "@/locales/nl-NL/auth/onboarding";
import loginPage from "@/locales/nl-NL/loginPage";
import loginPageSteps from "@/locales/nl-NL/loginPageSteps";
import dashboard from "@/locales/nl-NL/dashboard/dashboard";
import account from "@/locales/nl-NL/account/account";
import mailbox from "@/locales/nl-NL/account/mailbox";
import bankstatement from "@/locales/nl-NL/account/bankstatement";
import myApps from "@/locales/nl-NL/my-apps/myApps";
import about from "@/locales/nl-NL/about/about";
import contactService from "@/locales/nl-NL/about/contactService";
import contact from "@/locales/nl-NL/contact";
import salesPromotions from "@/locales/nl-NL/sales/promotions";
import brochures from "@/locales/nl-NL/sales/brochures";
import shop from "@/locales/nl-NL/shop/data";
import priceList from "@/locales/nl-NL/shop/priceList";
import staff from "@/locales/nl-NL/dashboard/staff";
import promotions from "@/locales/nl-NL/promotions";
import points from "@/locales/nl-NL/points";
import trainings from "@/locales/nl-NL/trainings/trainings";
import vouchers from "@/locales/nl-NL/vouchers/vouchers";
import generateReport from "@/locales/nl-NL/generate-report/generateReport";
import widgets from "@/locales/nl-NL/widgets/widgets";
import wholesaler from "@/locales/nl-NL/wholesaler/wholesaler";
import media from "@/locales/nl-NL/media/index";
import product from "@/locales/nl-NL/product/index";
import message from "@/locales/nl-NL/message/index";
import commitmentLetter from "@/locales/nl-NL/account/commitmentLetter";
import multiplicator from "@/locales/nl-NL/multiplicator";
import consents from "@/locales/nl-NL/consents/consents";
import investment from "@/locales/nl-NL/investment/data";
import kickback from "@/locales/nl-NL/kickback";

//prettier-ignore
const messages = {
  ...root.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  loginPage: loginPage.messages,
  loginPageSteps: loginPageSteps.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  contact: contact.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    desc: "Hier kunt u de salestools van de nieuwste  Bridgestone en Firestone producten downloaden.",
    technologiesTitle: "Technologieën, markeringen en meer",
    technologiesDesc:
      "Download hier de nieuwste brochures en flyers over onze technologieën, markeringen en meer voor auto's, SUV's en bestelwagens.",
    BDriveTitle: "Productafbeeldingen",
    BDriveLinkText: "Link naar het PRODUCTAFBEELDINGEN-portaal",
  },
}

export default {
  locale: "nl-NL",
  messages,
};
